import { render, staticRenderFns } from "./ProductCompositionTooltip.vue?vue&type=template&id=23fc30f2&"
import script from "./ProductCompositionTooltip.vue?vue&type=script&lang=js&"
export * from "./ProductCompositionTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports